import { render, staticRenderFns } from "./RequestPasswordReset.vue?vue&type=template&id=3785c780"
import script from "./RequestPasswordReset.vue?vue&type=script&lang=js"
export * from "./RequestPasswordReset.vue?vue&type=script&lang=js"
import style0 from "./RequestPasswordReset.vue?vue&type=style&index=0&id=3785c780&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports